/* ziwei-core.js · 紫微斗数排盘引擎
   1:1 移植 tools/ziwei.py。依赖 lunar.js(lunar-javascript)。
   浏览器端挂 window.ZiweiCore,Node 端挂 global.ZiweiCore。 */

(function (root) {
  'use strict';

  // ── 安全取模(JS % 会返回负数,Python 不会)──
  function mod(a, m) { return ((a % m) + m) % m; }

  // ── 基础常量 ──
  var ZHI = ['子','丑','寅','卯','辰','巳','午','未','申','酉','戌','亥'];
  var GAN = ['甲','乙','丙','丁','戊','己','庚','辛','壬','癸'];
  var Z = {}; ZHI.forEach(function (z, i) { Z[z] = i; });

  var PALACES = ['命宫','兄弟','夫妻','子女','财帛','疾厄',
                 '迁移','交友','官禄','田宅','福德','父母'];

  var WU_HU = {'甲':'丙','己':'丙','乙':'戊','庚':'戊','丙':'庚','辛':'庚',
               '丁':'壬','壬':'壬','戊':'甲','癸':'甲'};

  var _NAYIN_CYCLE = ['金','火','木','土','金',
                      '火','水','土','金','木',
                      '水','土','火','木','水'];
  var NAYIN_PAIRS = _NAYIN_CYCLE.concat(_NAYIN_CYCLE);

  var JU = {'水': [2, '水二局'], '木': [3, '木三局'], '金': [4, '金四局'],
            '土': [5, '土五局'], '火': [6, '火六局']};

  var SI_HUA = {
    '甲': ['廉贞','破军','武曲','太阳'], '乙': ['天机','天梁','紫微','太阴'],
    '丙': ['天同','天机','文昌','廉贞'], '丁': ['太阴','天同','天机','巨门'],
    '戊': ['贪狼','太阴','右弼','天机'], '己': ['武曲','贪狼','天梁','文曲'],
    '庚': ['太阳','武曲','太阴','天同'], '辛': ['巨门','太阳','文曲','文昌'],
    '壬': ['天梁','紫微','左辅','武曲'], '癸': ['破军','巨门','太阴','贪狼']
  };

  var LU_CUN = {'甲':'寅','乙':'卯','丙':'巳','丁':'午','戊':'巳',
                '己':'午','庚':'申','辛':'酉','壬':'亥','癸':'子'};
  var KUI_YUE = {'甲':['丑','未'],'戊':['丑','未'],'庚':['丑','未'],
                 '乙':['子','申'],'己':['子','申'],
                 '丙':['亥','酉'],'丁':['亥','酉'],
                 '壬':['卯','巳'],'癸':['卯','巳'],
                 '辛':['午','寅']};
  var HUO_LING = [
    [['寅','午','戌'], '丑', '卯'],
    [['申','子','辰'], '寅', '戌'],
    [['巳','酉','丑'], '卯', '戌'],
    [['亥','卯','未'], '酉', '戌']
  ];
  var MA_MAP = [
    [['寅','午','戌'], '申'],
    [['申','子','辰'], '寅'],
    [['巳','酉','丑'], '亥'],
    [['亥','卯','未'], '巳']
  ];
  var MING_ZHU = {'子':'贪狼','丑':'巨门','亥':'巨门','寅':'禄存','戌':'禄存',
                  '卯':'文曲','酉':'文曲','辰':'廉贞','申':'廉贞',
                  '巳':'武曲','未':'武曲','午':'破军'};
  var SHEN_ZHU = {'子':'火星','午':'火星','丑':'天相','未':'天相',
                  '寅':'天梁','申':'天梁','卯':'天同','酉':'天同',
                  '辰':'文昌','戌':'文昌','巳':'天机','亥':'天机'};

  var MAIN14 = ['紫微','天机','太阳','武曲','天同','廉贞','天府','太阴',
                '贪狼','巨门','天相','天梁','七杀','破军'];
  var MAIN14_SET = {};
  MAIN14.forEach(function (s) { MAIN14_SET[s] = true; });

  var SHA6 = ['擎羊', '陀罗', '火星', '铃星', '地空', '地劫'];
  var SPW = {'七杀':1, '破军':1, '贪狼':1};
  var JIYUE = {'天机':1, '太阴':1, '天同':1, '天梁':1};

  var MISC_SANHE = [
    [['寅','午','戌'], '戌', '卯'],
    [['申','子','辰'], '辰', '酉'],
    [['巳','酉','丑'], '丑', '午'],
    [['亥','卯','未'], '未', '子']
  ];
  var GU_GUA = [
    [['亥','子','丑'], '寅', '戌'],
    [['寅','卯','辰'], '巳', '丑'],
    [['巳','午','未'], '申', '辰'],
    [['申','酉','戌'], '亥', '未']
  ];

  var CS_START = {'水':'申', '土':'申', '木':'亥', '金':'巳', '火':'寅'};
  var CS12 = ['长生','沐浴','冠带','临官','帝旺','衰','病','死','墓','绝','胎','养'];

  // ── 纳音 ──
  function nayinElement(gan, zhi) {
    var g = GAN.indexOf(gan), z = Z[zhi];
    var idx = mod(6 * g - 5 * z, 60);
    return NAYIN_PAIRS[Math.floor(idx / 2)];
  }

  // ── 紫微星位 ──
  function ziweiPosition(ju, day) {
    var r = day % ju;
    if (r === 0) return mod(2 + day / ju - 1, 12);
    var n = ju - r;
    var shang = (day + n) / ju;
    var base = mod(2 + shang - 1, 12);
    return n % 2 === 0 ? mod(base + n, 12) : mod(base - n, 12);
  }

  // ── 三方四正 ──
  function sanFang(c, pos) {
    return [pos, mod(pos + 6, 12), mod(pos + 4, 12), mod(pos - 4, 12)];
  }

  function has(arr, v) { return arr.indexOf(v) !== -1; }
  function inGrp(grp, v) { return grp.indexOf(v) !== -1; }

  // ── 排盘核心 ──
  function chartFromLunar(yGan, yZhi, lmonth, lday, ti, gender) {
    var ming = mod(2 + (lmonth - 1) - ti, 12);
    var shen = mod(2 + (lmonth - 1) + ti, 12);

    var yinGan = GAN.indexOf(WU_HU[yGan]);
    var gongGan = {};
    for (var zi = 0; zi < 12; zi++) {
      gongGan[zi] = GAN[mod(yinGan + mod(zi - 2, 12), 10)];
    }

    var elem = nayinElement(gongGan[ming], ZHI[ming]);
    var juArr = JU[elem];
    var ju = juArr[0], juName = juArr[1];

    var zw = ziweiPosition(ju, lday);
    var tf = mod(4 - zw, 12);

    var stars = {};
    for (var i = 0; i < 12; i++) stars[i] = [];
    function put(pos, name) { stars[pos].push(name); }

    var aux = {};
    function putx(pos, name) { put(pos, name); aux[name] = pos; }

    // 紫微星系(逆行)
    var zwChain = [[0,'紫微'], [-1,'天机'], [-3,'太阳'],
                   [-4,'武曲'], [-5,'天同'], [-8,'廉贞']];
    zwChain.forEach(function (p) { put(mod(zw + p[0], 12), p[1]); });

    // 天府星系(顺行)
    var tfChain = [[0,'天府'], [1,'太阴'], [2,'贪狼'], [3,'巨门'],
                   [4,'天相'], [5,'天梁'], [6,'七杀'], [10,'破军']];
    tfChain.forEach(function (p) { put(mod(tf + p[0], 12), p[1]); });

    // 辅星
    putx(mod(10 - ti, 12), '文昌');
    putx(mod(4 + ti, 12), '文曲');
    putx(mod(4 + lmonth - 1, 12), '左辅');
    putx(mod(10 - (lmonth - 1), 12), '右弼');

    var ky = KUI_YUE[yGan];
    putx(Z[ky[0]], '天魁'); putx(Z[ky[1]], '天钺');

    var lu = Z[LU_CUN[yGan]];
    putx(lu, '禄存'); putx(mod(lu + 1, 12), '擎羊'); putx(mod(lu - 1, 12), '陀罗');
    putx(mod(11 + ti, 12), '地劫'); putx(mod(11 - ti, 12), '地空');

    HUO_LING.forEach(function (row) {
      if (inGrp(row[0], yZhi)) {
        putx(mod(Z[row[1]] + ti, 12), '火星');
        putx(mod(Z[row[2]] + ti, 12), '铃星');
      }
    });
    MA_MAP.forEach(function (row) {
      if (inGrp(row[0], yZhi)) putx(Z[row[1]], '天马');
    });

    var hong = mod(3 - Z[yZhi], 12);
    putx(hong, '红鸾'); putx(mod(hong + 6, 12), '天喜');

    putx(mod(9 + lmonth - 1, 12), '天刑');
    putx(mod(1 + lmonth - 1, 12), '天姚');

    MISC_SANHE.forEach(function (row) {
      if (inGrp(row[0], yZhi)) {
        putx(Z[row[1]], '华盖'); putx(Z[row[2]], '咸池');
      }
    });
    GU_GUA.forEach(function (row) {
      if (inGrp(row[0], yZhi)) {
        putx(Z[row[1]], '孤辰'); putx(Z[row[2]], '寡宿');
      }
    });

    // 四化
    var hua = {};
    var huaNames = SI_HUA[yGan];
    var huaMarks = ['禄','权','科','忌'];
    for (var hi = 0; hi < 4; hi++) {
      var nm = huaNames[hi], mark = huaMarks[hi];
      for (var pi = 0; pi < 12; pi++) {
        if (has(stars[pi], nm)) { hua[nm] = [mark, pi]; break; }
      }
    }

    // 十二宫
    var palace = {};
    for (var k2 = 0; k2 < 12; k2++) {
      palace[mod(ming - k2, 12)] = PALACES[k2];
    }

    // 大限
    var yangYear = GAN.indexOf(yGan) % 2 === 0;
    var forward = (yangYear && gender === 'male') || (!yangYear && gender === 'female');
    var daxian = {};
    for (k2 = 0; k2 < 12; k2++) {
      var pos = forward ? mod(ming + k2, 12) : mod(ming - k2, 12);
      daxian[pos] = [ju + k2 * 10, ju + k2 * 10 + 9];
    }

    // 长生
    var cs0 = Z[CS_START[elem]];
    var changsheng = {};
    for (k2 = 0; k2 < 12; k2++) {
      pos = forward ? mod(cs0 + k2, 12) : mod(cs0 - k2, 12);
      changsheng[pos] = CS12[k2];
    }

    return {
      changsheng: changsheng,
      gender: gender, y_gan: yGan, y_zhi: yZhi,
      lmonth: lmonth, lday: lday, t_zhi: ZHI[ti],
      ming: ming, shen: shen, ju: ju, ju_name: juName,
      ming_gz: gongGan[ming] + ZHI[ming],
      gong_gan: gongGan, stars: stars, hua: hua, palace: palace, daxian: daxian,
      forward: forward,
      ming_zhu: MING_ZHU[ZHI[ming]], shen_zhu: SHEN_ZHU[yZhi]
    };
  }

  // ── 结构特征 ──
  function features(c) {
    var f = {};
    var inv = {}; // 宫名 → 地支索引
    for (var key in c.palace) inv[c.palace[key]] = parseInt(key);
    var S = c.stars, ming = c.ming, shen = c.shen;
    var hua = {}; // 禄/权/科/忌 → 宫位
    for (var sn in c.hua) hua[c.hua[sn][0]] = c.hua[sn][1];

    var sf = sanFang(c, ming);
    var sfStars = {};
    sf.forEach(function (p) { S[p].forEach(function (s) { sfStars[s] = true; }); });
    var mingStars = {};
    S[ming].forEach(function (s) { mingStars[s] = true; });

    MAIN14.forEach(function (st) {
      f['命宫主星:' + st] = !!mingStars[st];
    });
    var hasMing14 = false;
    MAIN14.forEach(function (st) { if (mingStars[st]) hasMing14 = true; });
    f['命宫:无主星'] = !hasMing14;

    f['杀破狼:坐命'] = !!(SPW['七杀'] && mingStars['七杀']) ||
                       !!(SPW['破军'] && mingStars['破军']) ||
                       !!(SPW['贪狼'] && mingStars['贪狼']);
    var oppStars = {};
    S[mod(ming + 6, 12)].forEach(function (s) { oppStars[s] = true; });
    f['杀破狼:在对宫'] = (!!oppStars['七杀'] || !!oppStars['破军'] || !!oppStars['贪狼']) && !f['杀破狼:坐命'];
    f['府相朝垣'] = !!sfStars['天府'] && !!sfStars['天相'];
    var jiyueCount = 0;
    ['天机','太阴','天同','天梁'].forEach(function (s) { if (sfStars[s]) jiyueCount++; });
    f['机月同梁'] = jiyueCount >= 3;

    PALACES.forEach(function (nm) {
      f['身宫落:' + nm] = shen === inv[nm];
      f['化忌落:' + nm] = hua['忌'] === inv[nm];
      f['化禄落:' + nm] = hua['禄'] === inv[nm];
      f['禄存落:' + nm] = has(S[inv[nm]], '禄存');
      f['擎羊落:' + nm] = has(S[inv[nm]], '擎羊');
    });
    f['身命同宫'] = shen === ming;

    if (hua['忌'] !== undefined) {
      var jiPos = hua['忌'];
      var hasSha = false;
      SHA6.forEach(function (s) { if (has(S[jiPos], s)) hasSha = true; });
      f['化忌同宫见煞'] = hasSha;
      f['化忌坐命宫'] = jiPos === ming;
    } else {
      f['化忌同宫见煞'] = false;
      f['化忌坐命宫'] = false;
    }

    var luPos = -1, maPos = -1;
    for (var i = 0; i < 12; i++) {
      if (has(S[i], '禄存')) luPos = i;
      if (has(S[i], '天马')) maPos = i;
    }
    f['禄马交驰'] = maPos >= 0 && (luPos === maPos || mod(luPos - maPos, 12) === 6);
    f['双禄交流'] = hua['禄'] !== undefined &&
                    (hua['禄'] === luPos || mod(hua['禄'] - luPos, 12) === 6);

    var tanPos = -1;
    for (var i2 = 0; i2 < 12; i2++) { if (has(S[i2], '贪狼')) { tanPos = i2; break; } }
    f['火贪同宫'] = has(S[tanPos], '火星');
    f['铃贪同宫'] = has(S[tanPos], '铃星');

    f['命宫:见天马'] = !!mingStars['天马'];
    f['命宫:见禄存'] = !!mingStars['禄存'];
    f['命宫:见四煞'] = !!mingStars['擎羊'] || !!mingStars['陀罗'] ||
                       !!mingStars['火星'] || !!mingStars['铃星'];
    f['命宫:见空劫'] = !!mingStars['地空'] || !!mingStars['地劫'];
    f['命宫:昌曲同宫'] = !!mingStars['文昌'] && !!mingStars['文曲'];
    f['命宫:辅弼同宫'] = !!mingStars['左辅'] && !!mingStars['右弼'];

    // 财荫夹印
    var xiangPos = -1;
    for (var i3 = 0; i3 < 12; i3++) { if (has(S[i3], '天相')) { xiangPos = i3; break; } }
    var luStar = '';
    for (var sn2 in c.hua) { if (c.hua[sn2][0] === '禄') { luStar = sn2; break; } }
    function _cai(p) { return has(S[p], '禄存') || has(S[p], luStar); }
    var xa = mod(xiangPos + 1, 12), xb = mod(xiangPos - 1, 12);
    f['财荫夹印'] = (has(S[xa], '天梁') && _cai(xb)) || (has(S[xb], '天梁') && _cai(xa));

    var mp1 = mod(ming + 1, 12), mm1 = mod(ming - 1, 12);
    f['魁钺夹命'] = (has(S[mp1], '天魁') && has(S[mm1], '天钺')) ||
                    (has(S[mp1], '天钺') && has(S[mm1], '天魁'));
    f['羊陀夹命'] = (has(S[mp1], '擎羊') && has(S[mm1], '陀罗')) ||
                    (has(S[mp1], '陀罗') && has(S[mm1], '擎羊'));
    f['马头带箭'] = has(S[Z['午']], '擎羊') && (Z['午'] === ming || Z['午'] === shen);

    return f;
  }

  // ── 自检 ──
  function selftest(c) {
    var errs = [];
    var inv = {};
    for (var key in c.palace) inv[c.palace[key]] = parseInt(key);

    if (mod(inv['命宫'] - inv['迁移'], 12) !== 6)
      errs.push('迁移宫不在命宫对面');

    var d1 = mod(inv['命宫'] - inv['财帛'], 12);
    var d2 = mod(inv['命宫'] - inv['官禄'], 12);
    var ds = [d1, d2].sort(function (a, b) { return a - b; });
    if (ds[0] !== 4 || ds[1] !== 8)
      errs.push('命/财/官不成三合');

    var got = [];
    for (var pi = 0; pi < 12; pi++) {
      c.stars[pi].forEach(function (s) { if (MAIN14_SET[s]) got.push(s); });
    }
    if (got.length !== 14) errs.push('十四主星数量=' + got.length);
    var gotSet = {};
    got.forEach(function (s) { gotSet[s] = true; });
    MAIN14.forEach(function (s) {
      if (!gotSet[s]) errs.push('缺少主星:' + s);
    });

    for (var k = 0; k < 11; k++) {
      var cur = mod(2 + k, 12), nxtZi = mod(2 + k + 1, 12);
      var want = GAN[mod(GAN.indexOf(c.gong_gan[cur]) + 1, 10)];
      if (c.gong_gan[nxtZi] !== want) {
        errs.push('宫干不连续:' + ZHI[cur] + '=' + c.gong_gan[cur] + ' 之后应是' + want +
                  ',实为' + c.gong_gan[nxtZi]);
        break;
      }
    }

    var pairs = [['破军','天相'], ['天府','七杀']];
    pairs.forEach(function (pair) {
      var pa = -1, pb = -1;
      for (var pi = 0; pi < 12; pi++) {
        if (has(c.stars[pi], pair[0])) pa = pi;
        if (has(c.stars[pi], pair[1])) pb = pi;
      }
      if (mod(pa - pb, 12) !== 6) errs.push(pair[0] + pair[1] + '不成对宫');
    });
    // 紫微/贪狼:距离规则较宽(0/2/6/10 均合法),Python 版不报此对的错误

    return errs;
  }

  // ── 真太阳时(照搬 bazi-core.js 的做法)──
  function equationOfTime(date) {
    var start = new Date(date.getFullYear(), 0, 0);
    var n = Math.floor((date - start) / 86400000);
    var b = 2 * Math.PI * (n - 81) / 364;
    return 9.87 * Math.sin(2 * b) - 7.53 * Math.cos(b) - 1.5 * Math.sin(b);
  }

  var CN_DST = [
    [1986, 5,  4, 1986, 9, 14], [1987, 4, 12, 1987, 9, 13],
    [1988, 4, 17, 1988, 9, 11], [1989, 4, 16, 1989, 9, 17],
    [1990, 4, 15, 1990, 9, 16], [1991, 4, 14, 1991, 9, 15]
  ];
  function chinaDstOffsetMin(y, mo, d, h, mi) {
    if (y < 1986 || y > 1991) return 0;
    var t = Date.UTC(y, mo - 1, d, h, mi);
    for (var i = 0; i < CN_DST.length; i++) {
      var r = CN_DST[i];
      if (t >= Date.UTC(r[0], r[1] - 1, r[2], 3, 0) &&
          t <  Date.UTC(r[3], r[4] - 1, r[5], 2, 0)) return -60;
    }
    return 0;
  }

  function historicalOffsetSec(tzName, y, mo, d, h, mi) {
    if (!tzName) return null;
    var u0 = Date.UTC(y, mo - 1, d, h, mi);
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: tzName, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    }).formatToParts(new Date(u0));
    var g = function (t) { return parseInt(parts.find(function (p) { return p.type === t; }).value, 10); };
    var hh = g('hour'); if (hh === 24) hh = 0;
    return Math.round((Date.UTC(g('year'), g('month') - 1, g('day'), hh,
                                g('minute'), g('second')) - u0) / 1000);
  }

  function trueSolar(y, mo, d, h, mi, lng, tz) {
    var base = new Date(y, mo - 1, d, h, mi, 0);
    var offSec = historicalOffsetSec(tz, y, mo, d, h, mi);
    var meridian, dst;
    if (offSec === null) {
      meridian = 120; dst = chinaDstOffsetMin(y, mo, d, h, mi);
    } else {
      meridian = offSec / 3600 * 15; dst = 0;
    }
    var corr = dst + (lng - meridian) * 4 + equationOfTime(base);
    return { time: new Date(base.getTime() + corr * 60000), corr: corr, meridian: meridian };
  }

  // ── build:阳历→农历→排盘 ──
  function build(opts) {
    var y = opts.year, mo = opts.month, d = opts.day, h = opts.hour, mi = opts.minute;
    var lng = opts.lng, tz = opts.tz || null, gender = opts.gender;

    var ts = trueSolar(y, mo, d, h, mi, lng, tz);
    var solar = ts.time;

    // 北京时间(定农历年/月/日)
    var clock = new Date(y, mo - 1, d, h, mi, 0);
    var offSec = historicalOffsetSec(tz, y, mo, d, h, mi);
    var bjAdjustMin;
    if (offSec !== null) {
      bjAdjustMin = (8 - offSec / 3600) * 60;
    } else {
      bjAdjustMin = chinaDstOffsetMin(y, mo, d, h, mi);
    }
    var beijing = new Date(clock.getTime() + bjAdjustMin * 60000);

    // 农历日期 ← 北京时间;时辰 ← 真太阳时
    var lunBeijing = Solar.fromYmdHms(beijing.getFullYear(), beijing.getMonth() + 1,
      beijing.getDate(), beijing.getHours(), beijing.getMinutes(), 0).getLunar();
    var lunSolar = Solar.fromYmdHms(solar.getFullYear(), solar.getMonth() + 1,
      solar.getDate(), solar.getHours(), solar.getMinutes(), 0).getLunar();

    var yGz = lunBeijing.getYearInGanZhi();
    var lMonth = Math.abs(lunBeijing.getMonth());
    var lDay = lunBeijing.getDay();
    var ti = Z[lunSolar.getTimeZhi()];

    var c = chartFromLunar(yGz.charAt(0), yGz.charAt(1), lMonth, lDay, ti, gender);

    c.clock = clock;
    c.solar = solar;
    c.corr = ts.corr;
    c.beijing = beijing;
    c.place = opts.place || '';
    c.tz = tz;

    return c;
  }

  // ── i18n(英文)──
  var PALACE_EN = {
    '命宫':'Life', '兄弟':'Siblings', '夫妻':'Spouse', '子女':'Children',
    '财帛':'Wealth', '疾厄':'Health', '迁移':'Travel', '交友':'Friends',
    '官禄':'Career', '田宅':'Property', '福德':'Wellbeing', '父母':'Parents'
  };
  var STAR_EN = {
    '紫微':'Zi Wei','天机':'Tian Ji','太阳':'Tai Yang','武曲':'Wu Qu',
    '天同':'Tian Tong','廉贞':'Lian Zhen','天府':'Tian Fu','太阴':'Tai Yin',
    '贪狼':'Tan Lang','巨门':'Ju Men','天相':'Tian Xiang','天梁':'Tian Liang',
    '七杀':'Qi Sha','破军':'Po Jun',
    '文昌':'Wen Chang','文曲':'Wen Qu','左辅':'Zuo Fu','右弼':'You Bi',
    '天魁':'Tian Kui','天钺':'Tian Yue','禄存':'Lu Cun',
    '擎羊':'Qing Yang','陀罗':'Tuo Luo','地空':'Di Kong','地劫':'Di Jie',
    '火星':'Huo Xing','铃星':'Ling Xing','天马':'Tian Ma',
    '红鸾':'Hong Luan','天喜':'Tian Xi','天刑':'Tian Xing','天姚':'Tian Yao',
    '华盖':'Hua Gai','咸池':'Xian Chi','孤辰':'Gu Chen','寡宿':'Gua Su'
  };
  var HUA_EN = {'禄':'Hua Lu','权':'Hua Quan','科':'Hua Ke','忌':'Hua Ji'};
  var JU_EN = {'水二局':'Water 2','木三局':'Wood 3','金四局':'Metal 4',
               '土五局':'Earth 5','火六局':'Fire 6'};
  var CS_EN = {'长生':'Growth','沐浴':'Bathing','冠带':'Capping','临官':'Office',
               '帝旺':'Peak','衰':'Decline','病':'Illness','死':'Death',
               '墓':'Tomb','绝':'Severance','胎':'Conception','养':'Nurture'};

  root.ZiweiCore = {
    chartFromLunar: chartFromLunar, features: features, selftest: selftest,
    sanFang: sanFang, build: build, nayinElement: nayinElement,
    ziweiPosition: ziweiPosition,
    ZHI: ZHI, GAN: GAN, Z: Z, PALACES: PALACES, MAIN14: MAIN14,
    PALACE_EN: PALACE_EN, STAR_EN: STAR_EN, HUA_EN: HUA_EN,
    JU_EN: JU_EN, CS_EN: CS_EN, SI_HUA: SI_HUA
  };
})(typeof window !== 'undefined' ? window : global);
